export default __webpack_public_path__ + "static/media/REGULAMENTO ACADÉMICO-08.04.2024 .d816073e.pdf";